import React, { useState, useEffect } from 'react';
import axios from '../../../axiosConfig';
import { Form, Button, Modal, Table } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoading } from '../../../components/LoadingContext';
import { ToastContainer,toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import SelectComponent from '../../../components/SelectComponent';
import { cohortesActivas } from '../../../components/cohorteUtils';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons




 
    
const CreateCostoCurso = () => {
  

  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [curso,setCurso]=useState('');
  const { id } = useParams(); // Obtener el id del curso de la URL
    const userRole = localStorage.getItem('role');
    
const userId = parseInt(localStorage.getItem('user'));  // ID del usuario 

  useEffect(() => {
    setLoading(true);
    Promise.all([handleSeleccionar()]).finally(() => {
        setLoading(false);
    });
}, []);
  const [formData, setFormData] = useState({
    curso_id:id,
    costo_insc:'',
    total:'',
    costo_cuota:'',
    total_cuotas:'',
    num_cuotas:'',
    periodicidad:'',
    grupo:'',
    cohorte:'',
    periodo_id:'',
    centro_id:'',

  });

useEffect(() => {
  const inscripcion = parseFloat(formData.costo_insc) || 0;
  const costo_cuota = parseFloat(formData.costo_cuota) || 0;
  const num_cuotas = parseFloat(formData.num_cuotas) || 0;
  
  setFormData(prevState => ({
    ...prevState,
    total: inscripcion + (costo_cuota*num_cuotas)
  }));
}, [formData.costo_insc, formData.costo_cuota,formData.num_cuotas]);

   const [filterOptions, setFilterOptions] = useState({
      centroOptions: [],
      cohorteOptions: [],
      periodoOptions: [],
      grupoOptions: [],

  });

  const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
  const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
 const [showConfirmModal, setShowConfirmModal] = useState(false);  
const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios
const [selectedUserId, setSelectedUserId] = useState(null);
  const [comentario, setComentario] = useState('');  // Nuevo estado para el comentario
   const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
    const [currentPageUsers, setCurrentPageUsers] = useState(1);
    
    const [allRoles, setAllRoles] = useState([]); // Todos los roles cargados
    const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
    const [currentPageRoles, setCurrentPageRoles] = useState(1);
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
      const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
      const [showUserRoleModal, setShowUserRoleModal] = useState(false); 

    useEffect(() => {
     
      if (showUserSearchModal) {
        getAllUsers();
      } else if (showRoleSearchModal) {
        getAllRoles();
      }
    }, [showUserSearchModal, showRoleSearchModal]);
  
    const [filters, setFilters] = useState({
      username:'',
      name:''
    });



  const handleSeleccionar = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Suponiendo que el endpoint unificado sea `/filtros-cursos`
      const response = await axios.get(`/filtros-cursos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Desestructuramos los datos que vienen en la respuesta
      const {periodo,centro,grupo,cohorte} = response.data;
  
      // Retornamos las opciones en un solo objeto
      setFilterOptions( {
        periodoOptions: periodo,
        centroOptions: centro,
        grupoOptions:grupo,
        cohorteOptions:cohorte,
    
      });
  
    } catch (error) {
      console.error('Error fetching filter options:', error);
      
    }
  };

  
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};


const handleUserPageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllUsers(newPage);
  }
};

const handleRolePageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllRoles(newPage);
  }
};

  const getAllUsers = async (page = 1) => {
      try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`/users-paginate`, {
              headers: { Authorization: `Bearer ${token}` },
              params: { ...filters, page }, // Incluye `page` en los parámetros
          });
  
          const { data, last_page, current_page } = response.data.users;
  
          // Actualizar el estado
          setPaginatedUsers(data); // Datos de la página actual
          setCurrentPageUsers(current_page); // Página actual
          setTotalPages(last_page); // Total de páginas
      } catch (error) {
          console.error('Error fetching users:', error);
          toast.error('Error fetching data');
          setPaginatedUsers([]); // Limpia los datos en caso de error
      }
  };
  
  
  const getAllRoles = async (page = 1) => {
      try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`/role-paginate`, {
              headers: { Authorization: `Bearer ${token}` },
              params: { ...filters, page }, // Incluye `page` en los parámetros
          });
  
          const { data, last_page, current_page } = response.data.roles;
  
          setPaginatedRoles(data); // Datos de la página actual
          setCurrentPageRoles(current_page); // Página actual
          setTotalPages(last_page); // Total de páginas
      } catch (error) {
          console.error('Error fetching roles:', error);
          toast.error('Error fetching data');
          setPaginatedRoles([]); // Limpia los datos en caso de error
      }
  };





  const [error, setError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSelectUser = (user) => {
    setSelectedUserId(user.id);
    setSelectedUserName(user.username);
    setSelectedRoleId(null); // Limpiar selección de rol al seleccionar usuario
    setSelectedRoleName('');
    setShowUserSearchModal(false);
    setShowConfirmModal(true);
  };

  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);
    setSelectedRoleName(role.name);
    setSelectedUserId(null); // Limpiar selección de usuario al seleccionar rol
    setSelectedUserName('');
    setShowRoleSearchModal(false);
    setShowConfirmModal(true);
  };


  
  // const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setLoading(true);
  
     
  //       if (userRole!== 'admin') {
  
  //       try {
  //       const token = localStorage.getItem('token');
  //       if (!token) {
  //         toast.error('Error: Token no encontrado');
  //         return;
  //       }
  
  //       const formDataWithStatus = { ...formData, confirmar:false };
  //       const cursoResponse = await axios.post(`/costo-curso`, formDataWithStatus, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  
  //       const procedenciaId = cursoResponse.data.id;
  //       const requestData = {
  //         user_id: userId,
  //         destinatario_id:null,
  //         role_id: 4,
  //         zona_id: 18,
  //         status: false,
  //         finish_time: null,
  //         key: procedenciaId,
  //       };
  
  //       await axios.post(`/peticiones`, requestData, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  
  //       toast.success('Solicitud y Costo Curso  enviados exitosamente');
  //       navigate('/cursos');
  //     } catch (error) {
  //       toast.error('Error al enviar la solicitud o Costo Curso');
  //       console.error('Error al enviar la solicitud o Costo Curso :', error);
  //     }
  //       return;
  //     }
  
  //     try {
  //         const token = localStorage.getItem('token');
  //         if (!token) {
  //             toast.error('Error: Token no encontrado');
  //             setLoading(false);
  //             return;
  //         }
  
  //         const formDataWithStatus = {
  //             ...formData,
  //             confirmar:true,
  //         };
  
  //         // 1. Crear el curso primero
  //         const cursoResponse = await axios.post(`/costo-curso`, formDataWithStatus, {
  //             headers: { Authorization: `Bearer ${token}` },
  //         });
  
  //         toast.success('Nuevo Costo Curso agregado con Éxito');
  
  //             navigate('/cursos');
          
  //     } catch (error) {
  //         toast.error('Error al crear Procedencia ');
  //         console.error('Error creando Procedencia ', error);
  //     } finally {
  //         setLoading(false);
  //     }
  // };

const handleConfirmSendRequest = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }

      const formDataWithStatus = { ...formData, confirmar:false };
      const cursoResponse = await axios.post(`/costo-curso`, formDataWithStatus, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const procedenciaId = cursoResponse.data.id;
      const requestData = {
        user_id: userId,
        destinatario_id: selectedUserId || null,
        role_id: selectedRoleId || null,
        zona_id: 18,
        status: false,
        finish_time: null,
        key: procedenciaId,
        comentario: comentario
      };

      await axios.post(`/peticiones`, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success('Solicitud y Costo curso  enviados exitosamente');
      navigate('/cursos');
    } catch (error) {
      toast.error('Error al enviar la solicitud o Costo curso');
      console.error('Error al enviar la solicitud o Costo curso :', error);
    }
  };

   const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


      if (userRole!=='admin') {
      // Si no es admin se produce  la peticion

      setShowConfirmModal(true);
      setLoading(false);
      return;
    }

    try {
        const token = localStorage.getItem('token');
        if (!token) {
            toast.error('Error: Token no encontrado');
            setLoading(false);
            return;
        }

        const formDataWithStatus = {
            ...formData,
            confirmar:true,
        };

        // 1. Crear el curso primero
        const cursoResponse = await axios.post(`/costo-curso`, formDataWithStatus, {
            headers: { Authorization: `Bearer ${token}` },
        });

        toast.success('Nuevo Costo curso agregada con Éxito');

            navigate('/cursos');
        
    } catch (error) {
        toast.error('Error al crear Costo curso ');
        console.error('Error creando Costo curso ', error);
    } finally {
        setLoading(false);
    }
};


  
  



  return (
    <div className="row" style={{ marginTop: '50px' }}>
    <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
      <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
        <h2 className="mb-2">Crear Costo de Curso {curso.cod}</h2>
        <Form onSubmit={handleSubmit} className="custom-gutter">
           <Row className="g-2">
                  <Col md={6}>
              <Form.Group controlId="costo_insc">
                <Form.Label>Costo de Inscripcion ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="costo_insc"
                  value={formData.costo_insc}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              <Col md={6}>
              <Form.Group controlId="costo_cuota">
                <Form.Label>Costo de Cuotas ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="costo_cuota"
                  value={formData.costo_cuota}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
                </Form.Group>
                </Col>
                </Row>
                <Row className="g-2">
                <Col md={6}>
              <Form.Group controlId="num_cuotas">
                <Form.Label>Número de cuotas</Form.Label>
                <Form.Control
                  type="number"
                  name="num_cuotas"
                  value={formData.num_cuotas}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              <Col md={6}>
              <Form.Group controlId="periodicidad">
                <Form.Label>Periodicidad (núm de días)</Form.Label>
                <Form.Control
                  type="number"
                  name="periodicidad"
                  value={formData.periodicidad}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              </Row>
                <Form.Group controlId="total">
                <Form.Label>Costo Total ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="total"
                  value={formData.total}
                  onChange={handleChange}
                  maxLength={40}
                  readOnly
                />
                </Form.Group>
                <Row className="g-2">
                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      insertValueField="descripcion"
                      selectedValue={formData.grupo}
                      handleChange={handleChange}
                      controlId="grupo"
                      label="Grupo"
                      required
                  />

                  
                  
                  </Col>
                   <Col md={6}>
                  <SelectComponent
                      options={cohortesActivas(filterOptions.cohorteOptions)}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      insertValueField="descripcion"
                      selectedValue={formData.cohorte}
                      handleChange={handleChange}
                      controlId="cohorte"
                      label="Cohorte"
                      required
                  />
                  
              
                  
                  </Col>


                  </Row>
                  <Row className="g-2">
                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      selectedValue={formData.periodo_id}
                      handleChange={handleChange}
                      controlId="periodo_id"
                      label="Periodo"
                      required
                  />
                  
                  </Col>

                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.centroOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      selectedValue={formData.centro_id}
                      handleChange={handleChange}
                      controlId="centro_id"
                      label="Centro"
                      required
                  />
                  
                  </Col>
                  </Row>

                       {/* Modal para seleccionar usuario o rol */}
                                  <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
                               <Modal.Header closeButton>
                                 <Modal.Title>Enviar Petición</Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                 Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
                               </Modal.Body>
                               <Modal.Footer>
                                 <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
                                   Cancelar
                                 </Button>
                                 <Button variant="warning" onClick={() => {
                                   setShowUserRoleModal(false);
                                   setShowUserSearchModal(true);
                                 }}>
                                   Buscar Usuario
                                 </Button>
                                 <Button variant="info" onClick={() => {
                                   setShowUserRoleModal(false);
                                   setShowRoleSearchModal(true);
                                 }}>
                                   Buscar Rol
                                 </Button>
                               </Modal.Footer>
                             </Modal>
                       
                             {/* Modal de búsqueda de usuarios */}
                             <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
                               <Modal.Header closeButton>
                                 <Modal.Title>Buscar Usuario</Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                               <div className="d-flex align-items-center">
                                 <Form.Control
                                   name="username"
                                   type="text"
                                   placeholder="Buscar por nombre"
                                   value={filters.username}
                                   onChange={handleFilterChange}
                                   className="me-2"
                                 />
                                 <Button 
                                     variant="info me-2" 
                                     onClick={getAllUsers}
                                     style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                 >
                                     <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                 </Button>
                                 </div>
                                 <Table striped bordered hover>
                                   <thead>
                                     <tr>
                                       <th>ID</th>
                                       <th>Nombre</th>
                                       <th>Acciones</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     {paginatedUsers.length > 0 ? (
                                         paginatedUsers.map(user => (
                                             <tr key={user.id}>
                                                 <td>{user.id}</td>
                                                 <td>{user.username}</td>
                                                 <td>
                                                 <div className="d-flex justify-content-center align-items-center">
                       
                                                       <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                                           <i className="bi bi-check2-square"></i>
                                                       </Button>
                                                   </div>
                                                 </td>
                                             </tr>
                                         ))
                                     ) : (
                                         <tr>
                                             <td colSpan="3">No se encontraron usuarios.</td>
                                         </tr>
                                     )}
                                 </tbody>
                       
                                 </Table>
                                 <div className="d-flex justify-content-between mt-3">
                                 <Button
                                   variant="secondary"
                                     onClick={() => handleUserPageChange(currentPageUsers - 1)}
                                     disabled={currentPageUsers === 1}
                                 >
                                     Anterior
                                 </Button>
                                 <Button
                                     variant="secondary"
                                     onClick={() => handleUserPageChange(currentPageUsers + 1)}
                                     disabled={currentPageUsers === totalPages}
                                 >
                                     Siguiente
                                 </Button>
                       
                                 </div>
                               </Modal.Body>
                               <Modal.Footer>
                                 <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
                                   Cerrar
                                 </Button>
                                 <Button variant="light" onClick={() => {
                                   setShowUserSearchModal(false);
                                   setShowUserRoleModal(true);
                                 }}>
                                   Volver
                                 </Button>
                               </Modal.Footer>
                             </Modal>
                       
                             {/* Modal de búsqueda de roles */}
                             <Modal show={showRoleSearchModal} onHide={() => setShowRoleSearchModal(false)}>
                               <Modal.Header closeButton>
                                 <Modal.Title>Buscar Rol</Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                               <div className="d-flex align-items-center">
                                 <Form.Control
                                   name="name"
                                   type="text"
                                   placeholder="Buscar por nombre"
                                   value={filters.name}
                                   onChange={handleFilterChange}
                                   className="me-2" // Margen derecho para separar del botón
                                   style={{ flex: 1 }} // Ajusta el ancho para que ocupe el espacio disponible
                                 />
                                 <Button
                                   variant="info"
                                   onClick={getAllRoles}
                                   style={{ whiteSpace: 'nowrap' }} // Evita que el texto del botón se rompa en varias líneas
                                 >
                                   <FaSearch className="me-1" /> Buscar {/* Ícono de lupa */}
                                 </Button>
                               </div>
                       
                                 <Table striped bordered hover>
                                   <thead>
                                     <tr>
                                       <th>ID</th>
                                       <th>Nombre</th>
                                       <th>Acciones</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                   {paginatedRoles.length > 0 ? (
                                       paginatedRoles.map(role => (
                                           <tr key={role.id}>
                                               <td>{role.id}</td>
                                               <td>{role.name}</td>
                                               <td>
                       
                                                   <div className="d-flex justify-content-center align-items-center">
                       
                                                     <Button variant="info" onClick={() => handleSelectRole(role)} className="me-2">
                                                         <i className="bi bi-check2-square"></i>
                                                     </Button>
                                                   </div>
                                               </td>
                                           </tr>
                                       ))
                                   ) : (
                                       <tr>
                                           <td colSpan="3">No se encontraron roles.</td>
                                       </tr>
                                   )}
                               </tbody>
                       
                                 </Table>
                                 <div className="d-flex justify-content-between mt-3">
                                 <Button
                                   variant="secondary"
                                   onClick={() => handleRolePageChange(currentPageRoles - 1)}
                                   disabled={currentPageRoles === 1}
                               >
                                   Anterior
                               </Button>
                               <Button
                                   variant="secondary"
                                   onClick={() => handleRolePageChange(currentPageRoles + 1)}
                                   disabled={currentPageRoles === totalPages}
                               >
                                   Siguiente
                               </Button>
                       
                                 </div>
                               </Modal.Body>
                               <Modal.Footer>
                                 <Button variant="secondary" onClick={() => setShowRoleSearchModal(false)}>
                                   Cerrar
                                 </Button>
                                 <Button variant="light" onClick={() => {
                                   setShowRoleSearchModal(false);
                                   setShowUserRoleModal(true);
                                 }}>
                                   Volver
                                 </Button>
                               </Modal.Footer>
                             </Modal>
                       
                       
                             {/* Modal de confirmación para enviar la solicitud al usuario */}
                             <Modal show={selectedUserId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                               <Modal.Header closeButton>
                                 <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                 {selectedUserId
                                   ? `¿Seguro que deseas enviar la solicitud al usuario ${selectedUserName}?`
                                   : 'No se ha seleccionado ningún usuario.'}
                               </Modal.Body>
                               <Form.Group controlId="comentario" style={{ margin: '10px 20px' }}>
                                 <Form.Label>Comentario (opcional)</Form.Label>
                                 <Form.Control
                                   as="textarea"
                                   rows={3}
                                   placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                                   value={comentario}
                                   onChange={(e) => setComentario(e.target.value)}
                                   style={{ padding: '5px', resize: 'none' }}
                                 />
                               </Form.Group>
                               <Modal.Footer>
                                 <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                                 <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedUserId}>Confirmar</Button>
                                 <Button variant="light" onClick={() => {
                                   setShowConfirmModal(false);
                                   setShowUserSearchModal(true);
                                 }}>
                                   Volver
                                 </Button>
                               </Modal.Footer>
                             </Modal>
                       
                             {/* Modal de confirmación para enviar la solicitud al rol */}
                             <Modal show={selectedRoleId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                               <Modal.Header closeButton>
                                 <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                 {selectedRoleId
                                   ? <p>¿Seguro que deseas enviar la solicitud al rol {selectedRoleName}?</p>
                                   : <p>No se ha seleccionado ningún rol.</p>}
                                 <Form.Group controlId="comentario" style={{ margin: '10px 0' }}>
                                   <Form.Label>Comentario (opcional)</Form.Label>
                                   <Form.Control
                                     as="textarea"
                                     rows={3}
                                     placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                                     value={comentario}
                                     onChange={(e) => setComentario(e.target.value)}
                                     style={{ padding: '5px', resize: 'none' }}
                                   />
                                 </Form.Group>
                               </Modal.Body>
                               <Modal.Footer>
                                 <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                                 <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedRoleId}>Confirmar</Button>
                                 <Button variant="light" onClick={() => {
                                   setShowConfirmModal(false);
                                   setShowRoleSearchModal(true);
                                 }}>Volver</Button>
                               </Modal.Footer>
                             </Modal>



                
  
            
        <div className='mt-3'>
        <Button variant="success" type="submit">
          Guardar
        </Button>
        <Button 
          variant="secondary" 
          onClick={() => navigate('/cursos')}
          className="ms-2"
        >
          Volver
        </Button>
        </div>
      </Form>
    </div>
    </div>
    </div>
  );
};

export default CreateCostoCurso;
